import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { VenuesCollection } from '../models/VenuesCollection'
import { VENUE_COLLECTIONS_URL } from '../utils/urls'

const fetchVenuesCollections = (params: TableParams) =>
  SBAPI.FetchPaginated<VenuesCollection[]>(VENUE_COLLECTIONS_URL, params)

const fetchVenuesCollectionById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<VenuesCollection>(`${VENUE_COLLECTIONS_URL}/${id}`, params)

const createVenuesCollection = (venuesCollection: VenuesCollection) =>
  SBAPI.Post(VENUE_COLLECTIONS_URL, venuesCollection)

const updateVenuesCollection = (venuesCollection: VenuesCollection) =>
  SBAPI.Put(`${VENUE_COLLECTIONS_URL}/${venuesCollection.id}`, venuesCollection)

const deleteVenuesCollection = (venuesCollection: VenuesCollection) =>
  SBAPI.Delete(`${VENUE_COLLECTIONS_URL}/${venuesCollection.id}`)

const reorderVenuesCollection = (orderData: { id: number; order: number }[]) =>
  SBAPI.Post(`${VENUE_COLLECTIONS_URL}/reorder`, {
    venueCollections: orderData,
  })

export {
  createVenuesCollection,
  deleteVenuesCollection,
  fetchVenuesCollectionById,
  fetchVenuesCollections,
  reorderVenuesCollection,
  updateVenuesCollection,
}
